import TableHeader from '@/components/table/tableHeader';
import { ISort } from '@/components/table/types';
import { useResponsive } from '@/hooks/use-responsive';

import { Loader } from '@/components/loaders/loader';
import { TableBodyWrapper, TableWrapper } from '@/components/table/styles';
import { docusignRoutingTableColumns } from '../../constants';
import { EnvelopeRecipientDto } from '../../types';
import TableBody from './tableBody';
import MobileTable from './tableMobile';

interface TableProps {
  docusignRoutingTableData: EnvelopeRecipientDto[];
  sort: ISort;
  loading: boolean;
  refetch: () => void;
  setSort: (value: ISort) => void;
}

const Table = ({ docusignRoutingTableData, sort, setSort, refetch, loading }: TableProps) => {
  const { isMobile } = useResponsive();

  return (
    <TableWrapper padding="0">
      {isMobile ? (
        <>{loading ? <Loader /> : <MobileTable docusignRoutingTableData={docusignRoutingTableData} />}</>
      ) : (
        <>
          <TableHeader refetch={refetch} columns={docusignRoutingTableColumns} savedSort={sort} savedSetSort={setSort} />
          <TableBodyWrapper>{loading ? <Loader /> : <TableBody docusignRoutingTableData={docusignRoutingTableData} />}</TableBodyWrapper>
        </>
      )}
    </TableWrapper>
  );
};

export default Table;
